import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import FeatherIcon from "feather-icons-react";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { fetchBlogsWithAuthors } from "../../services/blogService";
import { BASE_URL_IMAGE } from "../../config/api";
import LoadingSpinner from "../../components/Common/LoadingSpinner";
import FormattedContentForCards from "../../components/Common/FormattedContentForCards";
import { encrypt } from "../../utils/encryption";
import { jwtDecode } from "jwt-decode";
import { fetchUserById } from "../../services/userService";

const BlogView = () => {
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loggedInUserData, setLoggedInUserData] = useState(null);

  const breadcrumbItems = [{ label: "Blogs" }];

  // 1️⃣ Fetch logged-in user
  useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(token);
        const user = await fetchUserById(decoded.id);
        setLoggedInUserData(user);
      } catch (error) {
        console.error("Error decoding token or fetching user:", error);
        localStorage.removeItem("token");
        setLoggedInUserData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAndSetUser();
  }, []);

  console.log(loggedInUserData);
  // 2️⃣ Fetch blogs only AFTER user data is available
  useEffect(() => {
    const fetchBlogs = async () => {
      if (!loggedInUserData) return; // Wait until user data is fetched
      setLoading(true);

      try {
        let blogsWithAuthors;
        switch (loggedInUserData.user_role) {
          case "1":
            // Admin – fetch all blogs
            blogsWithAuthors = await fetchBlogsWithAuthors({
              parameter: "Admin",
            });
            break;

          case "2":
            // Department head – fetch by department ID
            blogsWithAuthors = await fetchBlogsWithAuthors({
              id: loggedInUserData.department_id,
              parameter: "Department",
            });
            break;

          default:
            // Normal user – fetch by user ID
            blogsWithAuthors = await fetchBlogsWithAuthors({
              id: loggedInUserData.user_id,
              parameter: "Faculty",
            });
        }

        setBlogData(blogsWithAuthors);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [loggedInUserData]); // depends on user data

  // 3️⃣ Render
  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar
        id="menu-item11"
        id1="menu-items11"
        activeClassName="blog-grid"
      />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <Breadcrumb items={breadcrumbItems} />
              </div>
            </div>
          </div>

          {loading ? (
            <LoadingSpinner message="Fetching blogs..." />
          ) : blogData.length === 0 ? (
            <div className="text-center py-5">
              <h5>No blogs found.</h5>
            </div>
          ) : (
            <div className="row">
              {blogData.map((blog) => (
                <div
                  className="col-sm-6 col-md-6 col-xl-4 mb-4"
                  key={blog.blog_id}
                >
                  <div className="blog-card">
                    <div className="blog-image">
                      <Link
                        to={`/blog-detail/${encodeURIComponent(
                          encrypt(blog.blog_id)
                        )}`}
                      >
                        <img
                          src={`${BASE_URL_IMAGE}/uploads/blogImages/${blog.blog_image}`}
                          alt="Blog"
                        />
                      </Link>
                      <div className="blog-views">
                        <h5>{blog.blog_category}</h5>
                      </div>
                    </div>

                    <div className="blog-content">
                      <div className="blog-grp-blk">
                        <div className="blog-img-blk">
                          <img
                            className="img-fluid"
                            src={`${BASE_URL_IMAGE}/uploads/userProfiles/${blog.userImage}`}
                            alt="Author"
                            style={{ pointerEvents: "none", cursor: "default" }}
                          />
                          <div className="content-blk-blog ms-2">
                            <h4>{blog.blog_author_name}</h4>
                            <h5>{blog.designation}</h5>
                          </div>
                        </div>
                        <span>
                          <FeatherIcon icon="calendar" className="me-1" />
                          {new Date(blog.createdAt)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-")}
                        </span>
                      </div>

                      <h3 className="blog-title">
                        <Link
                          to={`/blog-detail/${encodeURIComponent(
                            encrypt(blog.blog_id)
                          )}`}
                        >
                          {blog.blog_title}
                        </Link>
                      </h3>

                      <p>
                        <FormattedContentForCards
                          htmlContent={blog.blog_description}
                        />
                      </p>

                      <div className="d-flex justify-content-between align-items-center mt-auto">
                        <Link
                          to={`/blog-detail/${encodeURIComponent(
                            encrypt(blog.blog_id)
                          )}`}
                          className="read-more d-flex"
                        >
                          View more{" "}
                          <i className="fa fa-long-arrow-right ms-2" />
                        </Link>
                        <div className="blog-buttons">
                          <Link
                            to={`/blog-detail/${encodeURIComponent(
                              encrypt(blog.blog_id)
                            )}`}
                            className="btn btn-sm btn-primary"
                          >
                            View
                          </Link>
                          <Link
                            to={`/edit-blog/${encodeURIComponent(
                              encrypt(blog.blog_id)
                            )}`}
                            className="btn btn-sm btn-quinary"
                          >
                            Edit
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogView;
